var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomCalendar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.992 4h-.97a.485.485 0 0 0-.486.485v3.396c0 .268.217.485.486.485h.97a.485.485 0 0 0 .485-.485V4.485A.485.485 0 0 0 9.992 4zM20.664 8.366h-.97a.485.485 0 0 1-.485-.485V4.485c0-.268.217-.485.485-.485h.97c.268 0 .485.217.485.485v3.396a.485.485 0 0 1-.485.485z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.03 5.94h-2.91v2.911a.485.485 0 0 1-.486.485h-2.91a.485.485 0 0 1-.486-.485v-2.91h-6.791v2.91a.485.485 0 0 1-.485.485h-2.91a.485.485 0 0 1-.486-.485v-2.91h-2.91a.97.97 0 0 0-.97.97v18.433c0 .536.434.97.97.97H25.03a.97.97 0 0 0 .97-.97V6.911a.97.97 0 0 0-.97-.97zm-.485 19.404H5.14a.485.485 0 0 1-.485-.485V11.762c0-.268.217-.486.485-.486h19.404c.267 0 .485.218.485.486v13.097a.485.485 0 0 1-.485.485z",
    fill: "#1E2969"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-calendar.b57436e7a67bf7bd7dfff829973f68e9.svg";